module.exports = __webpack_public_path__ + "static/media/youtube_sm.bf50b091200c74d0b405c762be03aae2.svg";